import { useEffect, useState } from 'react'

interface Data {
  session: Storage
  local: Storage
}

/** Exposes the browser storages once mounted; both are `undefined` during server rendering. */
export const useStorage = (onLoad?: (storage: Data) => void): Partial<Data> => {
  const [storage, setStorage] = useState<Partial<Data>>({
    local: undefined,
    session: undefined,
  })

  useEffect(() => {
    const next: Data = {
      local: localStorage,
      session: sessionStorage,
    }
    setStorage(next)
    onLoad && onLoad(next)
  }, [])

  return storage
}
